export default "__VITE_ASSET__0d8w7NMZ__"